/**
 * currentSeasonId selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { selectSeasons } from '../seasons/selectors';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

interface State {
    currentSeasonId?: number;
}

const selectCurrentSeasonId = (state: State) => state.currentSeasonId;

const selectCurrentSeason = createDeepEqualSelector(
    selectSeasons,
    selectCurrentSeasonId,
    (seasonsState, currentseasonId) =>
        currentseasonId && seasonsState[`${currentseasonId}`]
);

const selectCurrentSeasonIsComplete = createDeepEqualSelector(
    selectCurrentSeason,
    currentSeasonState =>
        !!(currentSeasonState && currentSeasonState.completedAt)
);

const makeSelectCurrentSeasonValue = (field: string) =>
    createDeepEqualSelector(
        selectCurrentSeason,
        currentSeasonState => currentSeasonState && currentSeasonState[field]
    );

export {
    selectCurrentSeasonId,
    selectCurrentSeason,
    selectCurrentSeasonIsComplete,
    makeSelectCurrentSeasonValue
};
